export default __webpack_public_path__ + "59974837c214943bad87986d7a997b79.png";